import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=6968f892&scoped=true&"
import script from "./popover.js?vue&type=script&lang=js&"
export * from "./popover.js?vue&type=script&lang=js&"
import style0 from "./popover.scss?vue&type=style&index=0&id=6968f892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968f892",
  null
  
)

export default component.exports